// Authentication hook that uses real Auth0
import { useAuth0 } from '@auth0/auth0-react';

export const useAppAuth = useAuth0;